"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _IdleOpportunity_internals;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdleOpportunity = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const chain_adapters_1 = require("@shapeshiftoss/chain-adapters");
const logger_1 = require("@shapeshiftoss/logger");
const toLower_1 = __importDefault(require("lodash/toLower"));
const web3_utils_1 = require("web3-utils");
const constants_1 = require("./constants");
const utils_1 = require("./utils");
const feeMultiplier = Object.freeze({
    fast: 1,
    average: 0.8,
    slow: 0.5,
});
class IdleOpportunity {
    constructor(deps, vault) {
        var _a;
        _IdleOpportunity_internals.set(this, void 0);
        __classPrivateFieldSet(this, _IdleOpportunity_internals, {
            chainAdapter: deps.chainAdapter,
            dryRun: deps.dryRun,
            logger: (_a = deps.logger) !== null && _a !== void 0 ? _a : new logger_1.Logger({ name: 'Idle Opportunity' }),
            routerContract: deps.contract,
            web3: deps.web3,
            network: deps.network,
        }, "f");
        // this.metadata = vault.metadata
        this.id = (0, toLower_1.default)(vault.address);
        this.metadata = {
            ...vault,
            apy: {
                net_apy: parseFloat((0, utils_1.bnOrZero)(vault.apr).div(100).toFixed()),
            },
        };
        this.version = `${vault.protocolName} ${vault.strategy}`.trim();
        this.name = vault.poolName;
        this.displayName = vault.poolName;
        this.isNew = false;
        this.expired = false;
        this.apy = (0, utils_1.bnOrZero)(vault.apr).div(100);
        this.tvl = {
            balanceUsdc: (0, utils_1.bnOrZero)(vault.tvl),
            balance: (0, utils_1.bnOrZero)(vault.underlyingTVL),
            assetId: (0, caip_1.toAssetId)({
                chainId: 'eip155:1',
                assetNamespace: 'erc20',
                assetReference: vault.address,
            }),
        };
        this.underlyingAsset = {
            balance: (0, utils_1.bn)(0),
            assetId: (0, caip_1.toAssetId)({
                chainId: 'eip155:1',
                assetNamespace: 'erc20',
                assetReference: vault.underlyingAddress,
            }),
        };
        this.positionAsset = {
            balance: (0, utils_1.bn)(0),
            assetId: (0, caip_1.toAssetId)({
                chainId: 'eip155:1',
                assetNamespace: 'erc20',
                assetReference: vault.address,
            }),
            underlyingPerPosition: (0, utils_1.bnOrZero)(vault.pricePerShare),
        };
        this.feeAsset = {
            assetId: 'eip155:1/slip44:60',
        };
    }
    /**
     * Prepare an unsigned withdrawal transaction
     *
     * @param input.address - The user's wallet address where the funds are
     * @param input.amount - The amount (as an integer value) of the position asset
     */
    async prepareWithdrawal(input) {
        const { address, amount } = input;
        // We use the vault directly to withdraw the vault tokens. There is no benefit to the DAO to use
        // the router to withdraw funds and there is an extra approval required for the user if we
        // withdrew from the vault using the shapeshift router. Affiliate fees for SS are the same
        // either way. For this reason, we simply withdraw from the vault directly.
        let methodName;
        let vaultContract;
        // Handle Tranche Withdraw
        if (this.metadata.cdoAddress) {
            vaultContract = new (__classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.Contract)(constants_1.idleCdoAbi, this.metadata.cdoAddress);
            const trancheType = /senior/i.test(this.metadata.strategy) ? 'AA' : 'BB';
            methodName = `withdraw${trancheType}`;
        }
        else {
            vaultContract = new (__classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.Contract)(constants_1.idleTokenV4Abi, this.id);
            methodName = `redeemIdleToken`;
        }
        const preWithdraw = await vaultContract.methods[methodName](amount.toFixed());
        const data = await preWithdraw.encodeABI({ from: address });
        const estimatedGas = (0, utils_1.bnOrZero)(await preWithdraw.estimateGas({ from: address }));
        const nonce = await __classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.getTransactionCount(address);
        const gasPrice = (0, utils_1.bnOrZero)(await __classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.getGasPrice());
        return {
            chainId: 1,
            data,
            estimatedGas,
            gasPrice,
            nonce: String(nonce),
            to: vaultContract.options.address,
            value: '0',
        };
    }
    async prepareClaimTokens(address) {
        const vaultContract = new (__classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.Contract)(constants_1.idleTokenV4Abi, this.id);
        const preWithdraw = await vaultContract.methods.redeemIdleToken(0);
        const data = await preWithdraw.encodeABI({ from: address });
        const estimatedGas = (0, utils_1.bnOrZero)(await preWithdraw.estimateGas({ from: address }));
        const nonce = await __classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.getTransactionCount(address);
        const gasPrice = (0, utils_1.bnOrZero)(await __classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.getGasPrice());
        return {
            chainId: 1,
            data,
            estimatedGas,
            gasPrice,
            nonce: String(nonce),
            to: vaultContract.options.address,
            value: '0',
        };
    }
    /**
     * Prepare an unsigned deposit transaction
     *
     * @param input.address - The user's wallet address where the funds are
     * @param input.amount - The amount (as an integer value) of the underlying asset
     */
    async prepareDeposit(input) {
        const { address, amount } = input;
        // In order to properly earn affiliate revenue, we must deposit to the vault through the SS
        // router contract. This is not necessary for withdraws. We can withdraw directly from the vault
        // without affecting the DAOs affiliate revenue.
        let methodName;
        let methodParams;
        let vaultContract;
        // Handle Tranche Deposit
        if (this.metadata.cdoAddress) {
            vaultContract = __classPrivateFieldGet(this, _IdleOpportunity_internals, "f").routerContract;
            const trancheType = /senior/i.test(this.metadata.strategy) ? 'AA' : 'BB';
            methodName = `deposit${trancheType}`;
            methodParams = [this.metadata.cdoAddress, amount.toFixed()];
        }
        else {
            methodName = 'mintIdleToken';
            methodParams = [amount.toFixed(), 'true', constants_1.referralAddress];
            vaultContract = new (__classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.Contract)(constants_1.idleTokenV4Abi, this.id);
        }
        const preDeposit = await vaultContract.methods[methodName](...methodParams);
        const data = await preDeposit.encodeABI({ from: address });
        const estimatedGas = (0, utils_1.bnOrZero)(await preDeposit.estimateGas({ from: address }));
        const nonce = await __classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.getTransactionCount(address);
        const gasPrice = (0, utils_1.bnOrZero)(await __classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.getGasPrice());
        return {
            chainId: 1,
            data,
            estimatedGas,
            gasPrice,
            nonce: String(nonce),
            to: vaultContract.options.address,
            value: '0',
        };
    }
    async getRewardAssetIds() {
        let govTokens = [];
        if (this.metadata.cdoAddress) {
            const cdoContract = new (__classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.Contract)(constants_1.idleCdoAbi, this.metadata.cdoAddress);
            const strategyContractAddress = await cdoContract.methods.strategy().call();
            const strategyContract = new (__classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.Contract)(constants_1.idleStrategyAbi, strategyContractAddress);
            govTokens = await strategyContract.methods.getRewardTokens().call();
        }
        else {
            const vaultContract = new (__classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.Contract)(constants_1.idleTokenV4Abi, this.id);
            govTokens = await vaultContract.methods.getGovTokens().call();
        }
        const rewardAssetIds = govTokens.map((token) => (0, caip_1.toAssetId)({
            assetNamespace: 'erc20',
            assetReference: token,
            chainId: caip_1.ethChainId,
        }));
        return rewardAssetIds;
    }
    /**
     * Prepare an unsigned deposit transaction
     *
     * @param address - The user's wallet address where the funds are
     */
    async getClaimableTokens(address) {
        if (this.metadata.cdoAddress) {
            return [];
        }
        const claimableTokens = [];
        const vaultContract = new (__classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.Contract)(constants_1.idleTokenV4Abi, this.id);
        const govTokensAmounts = await vaultContract.methods.getGovTokensAmounts(address).call();
        for (let i = 0; i < govTokensAmounts.length; i++) {
            const govTokenAddress = await vaultContract.methods.govTokens(i).call();
            if (govTokenAddress) {
                claimableTokens.push({
                    assetId: (0, caip_1.toAssetId)({
                        chainId: 'eip155:1',
                        assetNamespace: 'erc20',
                        assetReference: govTokenAddress,
                    }),
                    address: govTokenAddress,
                    amount: govTokensAmounts[i],
                });
            }
        }
        return claimableTokens;
    }
    async allowance(address) {
        const depositTokenContract = new (__classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.Contract)(constants_1.erc20Abi, this.metadata.underlyingAddress);
        let vaultContract;
        // Handle Tranche Withdraw
        if (this.metadata.cdoAddress) {
            vaultContract = __classPrivateFieldGet(this, _IdleOpportunity_internals, "f").routerContract;
        }
        else {
            vaultContract = new (__classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.Contract)(constants_1.idleTokenV4Abi, this.id);
        }
        const allowance = await depositTokenContract.methods
            .allowance(address, vaultContract.options.address)
            .call();
        return (0, utils_1.bnOrZero)(allowance);
    }
    async prepareApprove(address) {
        const depositTokenContract = new (__classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.Contract)(constants_1.erc20Abi, this.metadata.underlyingAddress);
        let vaultContractAddress;
        // Handle Tranche Withdraw
        if (this.metadata.cdoAddress) {
            vaultContractAddress = constants_1.ssRouterContractAddress;
        }
        else {
            vaultContractAddress = this.id;
        }
        const preApprove = await depositTokenContract.methods.approve(vaultContractAddress, constants_1.MAX_ALLOWANCE);
        const data = await preApprove.encodeABI({ from: address });
        const estimatedGas = (0, utils_1.bnOrZero)(await preApprove.estimateGas({ from: address }));
        const nonce = await __classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.getTransactionCount(address);
        const gasPrice = (0, utils_1.bnOrZero)(await __classPrivateFieldGet(this, _IdleOpportunity_internals, "f").web3.eth.getGasPrice());
        return {
            chainId: 1,
            data,
            estimatedGas,
            gasPrice,
            nonce: String(nonce),
            to: this.metadata.underlyingAddress,
            value: '0',
        };
    }
    /**
     * Sign and broadcast a previously prepared transaction
     */
    async signAndBroadcast(input) {
        const { wallet, tx, feePriority, bip44Params } = input;
        const feeSpeed = feePriority ? feePriority : 'fast';
        const chainAdapter = __classPrivateFieldGet(this, _IdleOpportunity_internals, "f").chainAdapter;
        const gasPrice = (0, web3_utils_1.numberToHex)((0, utils_1.bnOrZero)(tx.gasPrice).times(feeMultiplier[feeSpeed]).toString());
        const txToSign = {
            ...tx,
            gasPrice,
            // Gas limit safety factor of 50% to prevent out of gas errors on chain.
            gasLimit: (0, web3_utils_1.numberToHex)(tx.estimatedGas.times(1.5).integerValue().toString()),
            nonce: (0, web3_utils_1.numberToHex)(tx.nonce),
            value: (0, web3_utils_1.numberToHex)(tx.value),
            addressNList: (0, chain_adapters_1.toAddressNList)(bip44Params),
        };
        if (wallet.supportsOfflineSigning()) {
            const signedTx = await chainAdapter.signTransaction({ txToSign, wallet });
            if (__classPrivateFieldGet(this, _IdleOpportunity_internals, "f").dryRun)
                return signedTx;
            return chainAdapter.broadcastTransaction(signedTx);
        }
        else if (wallet.supportsBroadcast() && chainAdapter.signAndBroadcastTransaction) {
            if (__classPrivateFieldGet(this, _IdleOpportunity_internals, "f").dryRun) {
                throw new Error(`Cannot perform a dry run with wallet of type ${wallet.getVendor()}`);
            }
            return chainAdapter.signAndBroadcastTransaction({ txToSign, wallet });
        }
        else {
            throw new Error('Invalid HDWallet configuration');
        }
    }
    /**
     * This just makes the logging in the CLI easier to read
     * @returns
     */
    [(_IdleOpportunity_internals = new WeakMap(), Symbol.for('nodejs.util.inspect.custom'))]() {
        return {
            id: this.id,
            metadata: this.metadata,
            displayName: this.displayName,
            apy: this.apy.toString(),
            tvl: {
                assetId: this.tvl.assetId,
                balance: this.tvl.balance.toString(),
            },
            underlyingAsset: {
                balance: this.underlyingAsset.balance.toString(),
                assetId: this.underlyingAsset.assetId,
            },
            positionAsset: {
                balance: this.positionAsset.balance.toString(),
                assetId: this.positionAsset.assetId,
                price: this.positionAsset.underlyingPerPosition.toFixed(),
            },
        };
    }
}
exports.IdleOpportunity = IdleOpportunity;
